import * as React from 'react';
import { Typography, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useConsentStyles } from './styles';

// The account the decision applies to, with the way out to another account.
export default function AccountBlock({ name, email, onSwitchAccount, disabled }) {
  const { t } = useTranslation();
  const classes = useConsentStyles();

  return (
    <div className={classes.account}>
      <Typography variant="caption" color="textSecondary" component="div">
        {t('mcp.consent.accountLabel')}
      </Typography>
      <Typography variant="body1" className={classes.literal}>{name}</Typography>
      <Typography variant="body2" className={classes.literal}>{email}</Typography>
      <Link component="button" type="button" className={classes.link} onClick={onSwitchAccount} disabled={disabled}>
        {t('mcp.consent.switchAccount')}
      </Link>
    </div>
  );
}
